import { LocaleString } from '../translate/localeString.model';

export enum WebSocketTypeEnum {
    CACHE_UPDATE = 'CACHE_UPDATE',
	CACHE_REMOVE = 'CACHE_REMOVE',
	CACHE_RELOAD = 'CACHE_RELOAD',
	CACHE_UPDATE_DN = 'CACHE_UPDATE_DN',
	CACHE_REMOVE_DN = 'CACHE_REMOVE_DN',
	CACHE_RELOAD_DN = 'CACHE_RELOAD_DN',
	TASK_ROW_UPDATE = 'TASK_ROW_UPDATE',
    WORKSHIFT_ROW_UPDATE = 'WORKSHIFT_ROW_UPDATE',
    WORKSHIFT_USER_EVENT_UPDATE = 'WORKSHIFT_USER_EVENT_UPDATE',
	MASTER_ASYNC_UPLOADED = 'MASTER_ASYNC_UPLOADED',
    TASKS_ASYNC_UPLOADED = 'TASKS_ASYNC_UPLOADED',
    GENERIC_ALERT = 'GENERIC_ALERT',
    SYSTEM_CHANGES = 'SYSTEM_CHANGES'
}

export interface WebSocketMessage {
    type: WebSocketTypeEnum;
    payload: any;
}

export interface WebSocketGenericMessage extends WebSocketMessage {
    receivedDate: string;
}
export interface GenericAlertConfig {
    alertType: GenericAlertType;
	dismissible: boolean;
	showIcon: boolean;
	alertTitle: LocaleString;
	alertText: LocaleString;
	downloadFile: string;
}

export enum GenericAlertType {
    info = 'info',
	success = 'success',
	warning = 'warning',
	error = 'error'
}
